import React from 'react';
import classnames from 'classnames';
import * as styles from './base.scss';
import * as layout from './../../../styles/objects/layout.scss';
const APPEARANCES = {
    default: styles.base,
    narrow: layout.narrow,
    divider: styles.divider,
};
const createComponent = ({ baseClassName = undefined, tagName = 'div' } = {}) => (props) => {
    const appearanceList = (typeof props.appearance === 'string'
        ? [props.appearance]
        : props.appearance || []);
    let divProps = Object.assign({}, props);
    delete divProps.appearance;
    delete divProps.layout;
    return React.createElement(tagName, Object.assign({}, divProps, {
        className: classnames(baseClassName, appearanceList.map(name => APPEARANCES[name]), props.layout && styles[`layout${props.layout}`], props.className),
    }), props.children);
};
// The `<Basic>`-component is a basic page layout component which is usually a child component to `<Layout>`.
//  - {string} `className` - Passes through the value on the root element `className`.
//  - {string} `appearance` - Apply diffent appearances. Available appearances are:
//     - `default` - Centers content with default page width. Default to `<Main>`-component.
//     - `narrow` - Centers content with narrow page width.
//     - `divider` - Adds a rule (vertical and horizontal) between part childrens.
//  - {string} `layout` - Layouts the component childrens. Available layout names are:
//     - `1to1` - First child ratio 1:2 and second child ratio 1:2 (| x | x |)
//     - `2to1` - First child ratio 2:3 and second child ratio 1:3 (| x x | x |)
//     - `3to1` - First child ratio 3:4 and second child ratio 1:4 (| x x x | x |)
//     - `1to2` - First child ratio 1:3 and second child ratio 2:3 (| x | x x |)
//     - `1to3` - First child ratio 1:4 and second child ratio 3:4 (| x | x x x |)
//     - `2to5` - First child ratio 2:5 and second child ratio 2:5 (| x x | x x x |)
//     - `3to7` - First child ratio 3:10 and second child ratio 7:10 (| x x x | x x x x x x x |)
export const Basic = createComponent();
// `<Part>`, `<Section>` and `<Article>` is like the `<Basic>`-component but adds spacing between (top and bottom) blocks.
// The difference is that `<Part>` is a `<div>`-tag, `<Section>` is a `<section>`-tag and `<Article>` is a `<article>`-tag.
export const Part = createComponent({
    baseClassName: styles.part,
});
export const Section = createComponent({
    baseClassName: styles.part,
    tagName: 'section',
});
export const Article = createComponent({
    baseClassName: styles.part,
    tagName: 'article',
});
export const Form = createComponent({
    baseClassName: styles.part,
    tagName: 'form',
});
// Default component a.k.a. `<Main>` centers the content with white background.
export const Main = createComponent({
    baseClassName: styles.main,
    tagName: 'main',
});
export default Main;
